/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-03-29 13:33:08
 * @LastEditors: linxi
 * @LastEditTime: 2023-11-29 14:15:59
 */
import { Settinglable } from "../models/personalSetting"
import { StationCategory, toJson, User } from "../models/user"
import { ADMIN_API_PREFIX, API_PREFIX } from "./constant"
import { ContentType, MultiPartFormData, Request } from "./request"

export interface GetUserListParams {
  current: number
  size?: number
  outpatientDepartmentId?: string
  innerDepartmentId?: string
  param?: string
  state?: number
  tenantId?: string
  stationCategory?: number
}

export interface CreateUserParams {
  tenantId?: string
  user: User
  diagnoses?: string
  prescription?: string
}

export interface shopTypeParams {
  tenantId?: number
  userId?: number
}
export interface shopTypeBody {
  code?: string
  codeName?: string
  userId?: number
}

export function createOrUpdateUser(params: CreateUserParams): Request {
  return {
    url: params.tenantId
      ? `${ADMIN_API_PREFIX}/tenant/user/save`
      : `${API_PREFIX}/blade-user/user/submit`,
    method: 'POST',
    body: { ...toJson(params.user), tenantId: params.tenantId },
  }
}

export function saveSettingLable(body: Settinglable): Request {
  return {
    url: `${API_PREFIX}/blade-user/personage/submit`,
    method: 'POST',
    body,
  }
}

export interface medicalHistorySaveSettingBody {
  fieldConfigs?: any
  records?: Settinglable
}


export function medicalHistorySaveSetting(body: medicalHistorySaveSettingBody): Request {
  return {
    url: `${API_PREFIX}/blade-user/personage/savePersonalPreferencesOfWeb`,
    method: 'POST',
    body,
  }
}

export function saveCwcaOptId(body: string): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/cwca/saveCwcaOptId`,
    method: 'POST',
    body,
  }
}

export interface GetUserDetailParams {
  tenantId?: string
  userId: string
}

export function getUserDetail(params: GetUserDetailParams): Request {
  return {
    url: params.tenantId
      ? `${ADMIN_API_PREFIX}/tenant/user/detail`
      : `${API_PREFIX}/blade-user/user/detail`,
    method: 'POST',
    params: {
      userId: params.userId,
    },
  }
}

export function setShopType(body: shopTypeBody): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/personage/submit`,
    method: 'POST',
    body,
  }
}

export function getShopType(params: shopTypeParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/personage/detail`,
    method: 'GET',
    params,
  }
}

export interface ToggleUserStateParams {
  tenantId?: string
  userId: string
}

export function toggleUserState(params: ToggleUserStateParams): Request {
  return {
    url: params.tenantId
      ? `${ADMIN_API_PREFIX}/tenant/user/logoutOrEnable`
      : `${API_PREFIX}/blade-user/user/logoutOrEnable`,
    method: 'POST',
    params: {
      userId: params.userId,
    },
  }
}

export interface ResetUserPasswordParams {
  id: string
  phone: string
  tenantId?: string
}

export function resetUserPassword(params: ResetUserPasswordParams): Request {
  return {
    url: params.tenantId
      ? `${ADMIN_API_PREFIX}/tenant/user/passwordReset`
      : `${API_PREFIX}/blade-user/user/password/reset`,
    method: 'POST',
    body: {
      id: params.id,
      phone: params.phone,
    },
  }
}

export function getUserProfile(): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/profile`,
    method: "GET",
  }
}

// 上传电子签名
export interface SignatureParams {
  file?: any;
  userId?: string
}
export function uploadSignature(params: SignatureParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/usersign/submitSign`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

// 获取电子签名
export function getSignature(userId?: any): Request {
  return {
    url: `${API_PREFIX}/blade-user/usersign/getUserSign`,
    method: 'GET',
    params: { userId },
  }
}



export interface SignatureEntityParams {
  userId?: any
  tenantId?: any
  signId?: any
}
// 获取电子签名
export function getSignatureEntity(body?: SignatureEntityParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/userSign/getUserSignEntity`,
    method: 'POST',
    body,
  }
}


// 删除电子签名
export function deleteSignature(userId?: any): Request {
  return {
    url: `${API_PREFIX}/blade-user/usersign/signRemove`,
    method: 'GET',
    params: { userId },
  }
}
// 删除电子签名
export function getSignatureAsyncNumFn(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/product/getProductUse`,
    method: 'GET',
    params: { type: '12' },
  }
}

export function selectTenantPrintTemplateWithTemplateCodeFn(param: any): Request {
  return {
    url: `${API_PREFIX}/blade-user/tenantprinttemplate/selectTenantPrintTemplateWithTemplateCode`,
    method: "GET",
    params: param,
  }
}

export interface UserProfileParams {
  userId?: any
  flag?: any
}
export function getUserProfileList(params: UserProfileParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/personage/getPersonalPreferencesOfWeb`,
    method: "GET",
    params,
  }
}

export function getAllPersonalPreferences(params: UserProfileParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/personage/getAllPersonalPreferences`,
    method: "GET",
    params,
  }
}
// 获取微诊所是否绑定
export function getWXBindingFn(): Request {
  return {
    url: `${API_PREFIX}/blade-user/userApplet/getIsBinding`,
    method: "GET",
  }
}
// 解除微诊所绑定
export function removeBindingFn(): Request {
  return {
    url: `${API_PREFIX}/blade-user/userApplet/tenantUserUntie`,
    method: "POST",
  }
}


export interface changePasswordBody {
  oldPwd: string
  newPwd: string
}

export function getChangePasswordSave(body: changePasswordBody): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/vaschangepwd`,
    method: "POST",
    body,
  }
}
export interface TcmSuggesstionInfoParam {
  treatmentId: string
}
export function getTcmSuggesstionInfoAsync(body:TcmSuggesstionInfoParam):Request {
  return {
    url: `${API_PREFIX}/blade-reminder/recipeSuggestion/recipeSuggestion`,
    method: "POST",
    body,
  }

}


// 处方属性项接口（功效、主治、用法等）
export interface PrescriptionAttribute {
  field: string; //字段名
  title: string; //标题
  content: string; //内容
}

// 处方药材项接口
export interface PrescriptionItem {
  // madId: number; //药品ID
  madName: string; //药品名称
  dose: number; //用量
  unit: string;  //单位
  direction: string; //用法
  localItemId: number; //本地目录ID
  localStockCnt: number; //本地库存数量
}

// 处方详情接口
export interface Prescription {
  id: number;  //处方ID
  code: string;  //方剂编码
  name: string;  //方剂名
  alias: string; //别名
  categoryName: string; //一级类别名称
  subCategoryName: string;  //二级类别名称
  usageName: string; //处方用法名称
  itemList: Record<string, never>; // 药品明细
  attributes: PrescriptionAttribute[]; //属性描述
}

// 单个方剂治疗项接口
export interface SuggessRecipe {
  preType: string; //处方类型
  classify: string; //分型
  preId: number; //处方ID
  preName: string; //处方名称
  recommended: string; //推荐指数
  prescription: Prescription; //草药处方
  prescriptionItems: PrescriptionItem[];  //草药处方明细
  // parentDrugs: Record<string, never>; // 中成药
  // appropriateTech: Record<string, never>; //针灸处方
  // appropriateTechItems: Record<string, never>; //针灸处方明细
}

// 最外层的处方列表接口
export interface PrescriptionList {
  preType: string;
  treatments: SuggessRecipe[];
}